import { Star } from "lucide-react";

interface SuggestionChipProps {
  emoji: string;
  label: string;
  onClick: () => void;
  delay: number;
  isFavorited?: boolean;
  onToggleFavorite?: () => void;
  isProFeature?: boolean;
}

const BASE_DELAY = 80;

const SuggestionChip = ({
  emoji,
  label,
  onClick,
  delay,
  isFavorited = false,
  onToggleFavorite,
  isProFeature = false,
}: SuggestionChipProps) => (
  <button
    onClick={onClick}
    className="animate-stagger-in bg-card rounded-[14px] px-3 py-4 shadow-kin-light text-left
      flex items-center gap-3 h-[68px] w-full relative
      border border-transparent active:border-kin-periwinkle active:-translate-y-0.5
      active:shadow-kin-elevated transition-all duration-200 cursor-pointer"
    style={{ opacity: 0, animationDelay: `${BASE_DELAY + delay}ms` }}
  >
    <span className="text-2xl leading-none flex-shrink-0">{emoji}</span>
    <span className="font-body text-sm font-medium text-foreground flex-1 pr-3 flex items-center flex-wrap gap-[6px]">
      <span className="leading-[1.3] line-clamp-2">{label}</span>
      {isProFeature && (
        <span
          aria-label="Kin Pro feature"
          style={{
            backgroundColor: "#5050C8",
            color: "white",
            borderRadius: 999,
            fontSize: 9,
            fontWeight: 600,
            padding: "2px 6px",
            lineHeight: 1.4,
            pointerEvents: "none",
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            flexShrink: 0,
            whiteSpace: "nowrap",
          }}
        >
          ⚡ PRO
        </span>
      )}
    </span>

    {onToggleFavorite && (
      <span
        role="button"
        tabIndex={0}
        aria-label={isFavorited ? "Unfavorite" : "Favorite"}
        onClick={(e) => {
          e.stopPropagation();
          onToggleFavorite();
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            e.stopPropagation();
            onToggleFavorite();
          }
        }}
        className="absolute flex items-center justify-center"
        style={{
          top: 0,
          right: 0,
          width: 32,
          height: 32,
        }}
      >
        <Star
          size={14}
          className={isFavorited ? "fav-star-filled" : "fav-star-outline"}
          fill={isFavorited ? "#5050C8" : "none"}
          stroke={isFavorited ? "#5050C8" : "#C8C8F4"}
          strokeWidth={2}
          style={{
            filter: isFavorited
              ? "drop-shadow(0 0 3px rgba(80, 80, 200, 0.5))"
              : "none",
          }}
        />
      </span>
    )}
  </button>
);

export default SuggestionChip;
